import { FC } from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import { money } from "@/utils/numeral/money";

interface OpportunitiesTopOpportunitiesOtherWithPopoverProps {
  value: number;
  spread: { name: string; value: number }[];
}

export const TopOpportunitiesOtherWithPopover: FC<
  OpportunitiesTopOpportunitiesOtherWithPopoverProps
> = ({ value, spread }) => {
  return (
    <Tooltip
      arrow
      placement="right"
      componentsProps={tooltipComponentsProps}
      title={
        <Stack p={1} spacing={1}>
          <Typography
            variant="caption"
            fontWeight="medium"
            color="text.secondary"
          >
            Other Opportunities
          </Typography>

          {spread.map(({ name, value }) => {
            return (
              <Stack
                key={name}
                spacing={1}
                direction="row"
                justifyContent="space-between"
              >
                <Typography
                  variant="caption"
                  whiteSpace="nowrap"
                  color="text.secondary"
                >
                  {name}
                </Typography>

                <Typography
                  variant="caption"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  {money(value)}
                </Typography>
              </Stack>
            );
          })}
        </Stack>
      }
    >
      <Typography
        sx={{
          pl: 2.5,
          textDecoration: "underline",
          textDecorationStyle: "dashed",
        }}
        variant="caption"
        color="text.secondary"
        fontWeight="medium"
      >
        {money(value)}
      </Typography>
    </Tooltip>
  );
};

const tooltipComponentsProps = {
  tooltip: {
    sx: {
      p: 0,
      boxShadow: 7,
      color: "text.primary",
      bgcolor: "background.paper",
      "& .MuiTooltip-arrow": { color: "background.paper" },
    },
  },
};
